module.exports = __webpack_public_path__ + "static/neha-94c8ededa97d9d662691685bae088e19.jpg";